import ApiResponse from '~/graphql/wrappers/api-response';

export default class MutationResponse<T = Mutation> extends ApiResponse<T> {
  constructor(operationResult) {
    super(operationResult.error);
    if (operationResult.data) {
      this.setData(operationResult.data);
    }
  }
}
